import { useTheme } from "@emotion/react";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import useTamanhoTela from "../../utils/useTamanhoTela";
import {
  BotaoAzulPreenchido,
  BotaoAzulVazado,
  BotaoVerdePreenchido,
  BotaoVermelhoVazado,
} from "../Botao";
import * as S from "./styles";

export const NavegacaoHeader = ({
  titulo,
  cor,
  botaoConfirmar = {
    onClick: {},
    texto: "",
    icone: "",
    disabled: false,
    cor: "",
    tabindex: 0,
    refs: {},
    tipo: "",
  },
  botaoVoltar = {
    onClick: {},
    texto: "",
    icone: "",
    cor: "",
    tipo: "",
  },
  botaoAdicional = {
    onClick: {},
    texto: "",
    icone: "",
    cor: "",
    tipo: "",
    disabled: false,
  },
  headerFixo,
  breadcrumb,
}) => {
  const { largura } = useTamanhoTela();
  const theme = useTheme();

  const identificarTipoBtn = (valor) => {
    if (botaoConfirmar.texto === undefined && botaoConfirmar.icone === undefined) {
      return <></>;
    }

    switch (valor) {
      case "Gravar":
        return (
          <BotaoVerdePreenchido
            cor={botaoConfirmar.cor}
            tamanho={headerFixo ? "SM" : "MD"}
            style={{
              justifySelf: "flex-end",
              color: theme.cores.neutral99,
              width: botaoConfirmar.largura ? botaoConfirmar.largura : undefined,
            }}
            texto={botaoConfirmar.texto}
            onClick={botaoConfirmar.onClick}
            disabled={botaoConfirmar.disabled}
            icone={botaoConfirmar.icone}
            tabindex={botaoConfirmar.tabindex}
            refs={botaoConfirmar.refs}
          />
        );

      case "Novo":
        return (
          <BotaoAzulPreenchido
            tamanho={headerFixo ? "SM" : "MD"}
            style={{ justifySelf: "flex-end" }}
            texto={botaoConfirmar.texto}
            onClick={botaoConfirmar.onClick}
            icone={botaoConfirmar.icone}
            tabindex={botaoConfirmar.tabindex}
          />
        );

      default:
        return (
          <BotaoAzulPreenchido
            cor={botaoConfirmar.cor}
            tamanho={headerFixo ? "SM" : "MD"}
            style={{ justifySelf: "flex-end", color: theme.cores.neutral99 }}
            texto={botaoConfirmar.texto}
            onClick={botaoConfirmar.onClick}
            icone={botaoConfirmar.icone}
          />
        );
    }
  };

  return largura > 768 ? (
    <>
      <S.ContainerNavegacaoHeader style={{ backgroundColor: cor }} headerFixo={headerFixo}>
        <S.DivBotoes>
          {botaoVoltar.texto !== "" ? (
            botaoVoltar.tipo !== "cancelar" ? (
              <BotaoAzulVazado
                tamanho={headerFixo ? "SM" : "MD"}
                texto={botaoVoltar.texto}
                onClick={botaoVoltar.onClick}
                icone={<FontAwesomeIcon icon={botaoVoltar.icone} />}
              />
            ) : (
              <BotaoVermelhoVazado
                tamanho={headerFixo ? "SM" : "MD"}
                texto={botaoVoltar.texto}
                onClick={botaoVoltar.onClick}
                icone={<FontAwesomeIcon icon={botaoVoltar.icone} />}
              />
            )
          ) : null}
        </S.DivBotoes>

        <S.TituloNavegacaoHeader headerFixo={headerFixo}>
          {headerFixo && <S.BreadcrumbCustom>{titulo}</S.BreadcrumbCustom>}
        </S.TituloNavegacaoHeader>

        {botaoAdicional.texto !== "" ? (
          <S.DivBotoes
            style={{
              width: botaoAdicional.largura !== undefined ? botaoAdicional.largura : 300,
              display: "flex",
              flexDirection: "row",
            }}
          >
            <S.IconeCustom>
              <BotaoAzulVazado
                style={{ marginRight: 20 }}
                tamanho={headerFixo ? "SM" : "MD"}
                texto={botaoAdicional.texto}
                disabled={botaoAdicional.disabled}
                onClick={botaoAdicional.onClick}
                icone={<FontAwesomeIcon icon={botaoAdicional.icone} />}
              />
            </S.IconeCustom>

            {identificarTipoBtn(botaoConfirmar.texto)}
          </S.DivBotoes>
        ) : (
          <S.DivBotoes>{identificarTipoBtn(botaoConfirmar.texto)}</S.DivBotoes>
        )}
      </S.ContainerNavegacaoHeader>
      <S.Divisor headerFixo={headerFixo} />
    </>
  ) : (
    <S.ContainerNavegacaoHeader>
      <S.TituloNavegacaoHeader>{titulo}</S.TituloNavegacaoHeader>

      <S.DivBotoes
        style={{
          width: "100%",
          flexDirection: "row",
          display: "flex",
          gap: 12,
          justifyContent: "space-around",
        }}
      >
        {botaoVoltar.texto !== "" ? (
          botaoVoltar.tipo !== "cancelar" ? (
            <BotaoAzulVazado
              texto={botaoVoltar.texto}
              onClick={botaoVoltar.onClick}
              style={{ width: largura > 767 ? "100%" : "50%" }}
              icone={<FontAwesomeIcon icon={faArrowLeft} />}
            />
          ) : (
            <BotaoVermelhoVazado
              tamanho={headerFixo ? "SM" : "MD"}
              texto={botaoVoltar.texto}
              onClick={botaoVoltar.onClick}
              style={{ width: largura > 767 ? "100%" : "50%", fontSize: 13 }}
              icone={undefined}
            />
          )
        ) : null}

        {botaoConfirmar.texto !== "" && botaoConfirmar.tipo !== "" ? (
          identificarTipoBtn(botaoConfirmar.texto)
        ) : (
          <BotaoAzulPreenchido
            cor={botaoConfirmar.cor}
            style={{
              justifySelf: "flex-end",
              color: theme.cores.neutral99,
              width: "100%",
            }}
            texto={botaoConfirmar.texto}
            onClick={botaoConfirmar.onClick}
            icone={botaoConfirmar.icone}
          />
        )}
      </S.DivBotoes>
    </S.ContainerNavegacaoHeader>
  );
};
